import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { brandInfo, faqList } from '@/mocks/about';

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于91吃瓜网',
  description: brandInfo.description,
  url: 'https://www.91chigua.com/about',
  about: {
    '@type': 'Organization',
    name: brandInfo.name,
    description: brandInfo.description,
    url: 'https://www.91chigua.com',
    email: brandInfo.contact.email,
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '北京市',
      addressCountry: 'CN',
    },
  },
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqList.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default function AboutPage() {
  return (
    <>
      <title>关于我们 - 91吃瓜网 | 品牌介绍与联系方式</title>
      <meta name="description" content="91吃瓜网是国内领先的娱乐八卦资讯平台，坚持真实、快速、全面的原则。了解品牌故事、平台声誉和联系方式。" />
      <meta name="keywords" content="91吃瓜网,关于91吃瓜网,91吃瓜爆料,吃瓜群众,娱乐八卦平台,联系我们" />
      <link rel="canonical" href="https://www.91chigua.com/about" />
      <script type="application/ld+json">{JSON.stringify(aboutJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <section className="pt-24 pb-14 md:pt-32 md:pb-20 bg-background-100">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="max-w-3xl">
                <span className="text-xs text-secondary-500 uppercase tracking-wider">关于我们</span>
                <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-foreground-950 leading-tight mt-3">
                  让每一个
                  <span className="inline-block mx-2 w-12 h-12 md:w-20 md:h-20 rounded-full overflow-hidden align-middle">
                    <img
                      src="https://readdy.ai/api/search-image?query=Warm%20dramatic%20spotlight%20texture%2C%20golden%20amber%20glow%2C%20entertainment%20abstract%2C%20cinematic%20light%20effect%2C%20soft%20bokeh%20circle&width=100&height=100&seq=about-intro-img-01&orientation=squarish"
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </span>
                  瓜
                  <br />
                  都被吃到
                </h1>
                <p className="mt-5 text-sm md:text-base text-foreground-500 max-w-xl leading-relaxed">
                  {brandInfo.description}
                </p>
                <div className="flex items-center gap-3 mt-8">
                  <a href="#contact" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap">
                    联系我们
                  </a>
                  <a href="#" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-foreground-800 text-foreground-800 text-sm hover:bg-foreground-800/5 transition-colors duration-200 whitespace-nowrap">
                    爆料投稿
                  </a>
                </div>
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-50">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
                {brandInfo.stats.map((stat, idx) => (
                  <div key={idx} className="text-center p-6 md:p-8 rounded-2xl bg-background-100">
                    <p className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-accent-500 mb-2">
                      {stat.value}
                    </p>
                    <p className="text-xs md:text-sm text-foreground-500">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-100">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-8">
                平台声誉
              </h2>
              <div className="max-w-3xl">
                <p className="text-base leading-relaxed text-foreground-700 mb-6">
                  {brandInfo.reputation}
                </p>
                <p className="text-base leading-relaxed text-foreground-700">
                  平台秉持&ldquo;真实、快速、全面&rdquo;的原则，建立了严格的内容审核机制，所有爆料均经过多方核实后发布。对于未经证实的传闻，我们会明确标注状态，让读者自行判断。91吃瓜网不仅是吃瓜群众的聚集地，更致力于成为娱乐资讯行业的标杆平台。
                </p>
              </div>
            </div>
          </section>

          <section id="contact" className="py-14 md:py-20 bg-background-50">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
                <div>
                  <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-6">
                    联系我们
                  </h2>
                  <div className="space-y-5">
                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-mail-line text-accent-600 text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">邮箱</p>
                        <a href={`mailto:${brandInfo.contact.email}`} className="text-sm text-foreground-500 hover:text-accent-500 transition-colors">
                          {brandInfo.contact.email}
                        </a>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-wechat-line text-accent-600 text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">微信公众号</p>
                        <p className="text-sm text-foreground-500">{brandInfo.contact.wechat}</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-weibo-line text-accent-600 text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">微博</p>
                        <p className="text-sm text-foreground-500">{brandInfo.contact.weibo}</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-map-pin-line text-accent-600 text-lg"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">地址</p>
                        <p className="text-sm text-foreground-500">{brandInfo.contact.address}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="relative w-full h-[350px] md:h-[420px] rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20office%20building%20exterior%2C%20warm%20golden%20hour%20lighting%2C%20urban%20cityscape%20background%2C%20professional%20corporate%20atmosphere%2C%20clean%20minimal%20architecture%2C%20amber%20tones%2C%20no%20visible%20people&width=800&height=560&seq=about-contact-bg&orientation=landscape"
                    alt="联系我们"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <p className="text-sm text-background-50/80">
                      有料就爆，让你的声音被听到
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-50 relative w-full h-[380px] md:h-[480px] overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20city%20skyline%20at%20night%2C%20warm%20golden%20lights%2C%20mysterious%20urban%20atmosphere%2C%20cinematic%20wide%20angle%2C%20dark%20sky%2C%20no%20visible%20people%2C%20editorial%20style%2C%20rich%20amber%20tones&width=1800&height=800&seq=about-cta-bg&orientation=landscape"
                alt="加入我们"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>
            </div>
            <div className="relative z-10 h-full flex items-center px-4 md:px-6">
              <div className="max-w-7xl mx-auto w-full grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                <div>
                  <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-none mb-6">
                    加入
                    <br />
                    吃瓜大军
                  </h2>
                  <Link
                    to="/"
                    className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-background-50 text-foreground-950 font-medium text-sm hover:bg-background-100 transition-colors duration-200 whitespace-nowrap"
                  >
                    回首页吃瓜
                    <span className="w-6 h-6 rounded-full bg-foreground-950 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-background-50 text-xs"></i>
                    </span>
                  </Link>
                </div>
                <div className="md:text-right">
                  <p className="text-sm md:text-base text-background-50/60 max-w-xs md:ml-auto leading-relaxed">
                    每天都有新鲜瓜等你来吃。
                    <br />
                    第一时间了解娱乐圈最新动态，
                    <br />
                    做最懂行的吃瓜群众。
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-100">
            <div className="max-w-3xl mx-auto px-4 md:px-6">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-10 text-center">
                常见问题
              </h2>
              <div className="space-y-3">
                {faqList.map((faq, idx) => (
                  <details key={idx} className="group bg-background-50 rounded-2xl overflow-hidden">
                    <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                      <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                        {faq.question}
                      </h3>
                      <span className="flex-shrink-0 w-7 h-7 rounded-full bg-background-100 flex items-center justify-center group-open:rotate-45 transition-transform duration-300">
                        <i className="ri-add-line text-foreground-600 text-sm"></i>
                      </span>
                    </summary>
                    <div className="px-5 md:px-6 pb-5 md:pb-6 pt-0">
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}